const PATH_PREFIX = '/admin/company/:companyID/minisite';

export default [
  {
    name: 'minisite.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'minisite.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'minisite.list',
    path: `${PATH_PREFIX}/list`,
  },
  {
    name: 'minisite.details',
    path: `${PATH_PREFIX}/:minisiteID/details`,
  },
  {
    name: 'minisite.pages',
    path: `${PATH_PREFIX}/:minisiteID/pages`,
  },
  {
    name: 'minisite.developer',
    path: `${PATH_PREFIX}/:minisiteID/developer`,
  },
  {
    name: 'minisite.theme',
    path: `${PATH_PREFIX}/:minisiteID/theme`,
  },
];
